import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { UpatedScofaFlagInModule } from "../../Services/PatchApi";
import { ClearSelection, HandleRowSelect, ScofaFlagSelectedRows } from "./ScofaAppData";
import { successModal, errorModal } from "../CustomModal";
import CustomLoader from "../CustomLoader";

const ScofaAppColumn = forwardRef((props, ref) => {

    const { item, category } = props;
    const [isScofaFlag, setScofaFlag] = useState(item.scofa_flag || false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        ClearSelection();
    }, []);

    const handleScofaFlag = async () => {
        try {

            if (ScofaFlagSelectedRows.length === 0) {
                return;
            }

            setLoader(true);
            const payload = {
                data: ScofaFlagSelectedRows,
                category_name: category
            }
            const result = await UpatedScofaFlagInModule(payload);
            setLoader(false);
            if (result?.status === 200) {
                successModal.fire({
                    text: "Scofa Changes Updated Successfully",
                    confirmButtonText: "Continue",
                });
                ClearSelection();
            }
        } catch (error) {
            setLoader(false);
        }
    };

    useImperativeHandle(ref, () => ({
        handleScofaFlag
    }));


    return (
        <>
            <td>
                <div className='mt-2'>
                    <input
                        type="checkbox"
                        checked={isScofaFlag}
                        onChange={() => {
                            if (!isScofaFlag && ScofaFlagSelectedRows.length >= 3) {
                                errorModal.fire({
                                    text: "You can only select up to 3 items.",
                                });
                                return;
                            }
                            setScofaFlag(!isScofaFlag);
                            HandleRowSelect({
                                "id": item.id,
                                "value": !isScofaFlag
                            });
                        }}
                    />
                </div>
            </td>
            {loader && <CustomLoader />}
        </>
    )
});

export default ScofaAppColumn;